import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers/rootReducer';
import { Middleware, SWRHook } from 'swr';

export const swrMiddleware: Middleware =
  (useSWRNext: SWRHook) => (key, fetcher, config) => {
    const auth = useSelector((state: RootState) => state.auth);

    // only fetch when logged in and session is not expired
    const filteredKey = auth && !auth.isSessionExpired && key ? key : null;

    return useSWRNext(filteredKey, fetcher, config);
  };
